import { motion } from 'framer-motion'
import { Play, Pause, RotateCcw, Home, Trophy, Settings } from 'lucide-react'
import { useGameStore } from '../store/gameStore'

interface GameMenuProps {
  isPaused: boolean
  onResume: () => void
  onStart: () => void
  onQuit: () => void
  gameOver: boolean
  won: boolean
}

export function GameMenu({ isPaused, onResume, onStart, onQuit, gameOver, won }: GameMenuProps) {
  const { score, kills } = useGameStore()

  if (gameOver) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="absolute inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50"
      >
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="panel p-8 text-center max-w-md"
        >
          <div className={`text-6xl font-bold mb-4 ${won ? 'neon-text' : 'neon-danger'}`}>
            {won ? 'VICTORY!' : 'DEFEAT'}
          </div>
          
          <div className="text-2xl text-white/70 mb-2">
            {won ? 'You survived!' : 'Better luck next time'}
          </div>

          <div className="flex justify-center gap-8 my-6">
            <div className="text-center">
              <div className="text-3xl font-bold text-oded-accent">{score}</div>
              <div className="text-xs text-white/50">Score</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-oded-danger">{kills}</div>
              <div className="text-xs text-white/50">Kills</div>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <button onClick={onStart} className="btn-primary flex items-center justify-center gap-2">
              <RotateCcw size={18} />
              Play Again
            </button>
            <button onClick={onQuit} className="btn-secondary flex items-center justify-center gap-2">
              <Home size={18} />
              Main Menu
            </button>
          </div>
        </motion.div>
      </motion.div>
    )
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="absolute inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50"
    >
      <motion.div
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        className="panel p-8 text-center"
      >
        <h1 className="text-5xl font-bold neon-text mb-2">ODED</h1>
        <p className="text-white/50 mb-8">Battle Royale</p>

        <div className="flex flex-col gap-3 w-64">
          {isPaused ? (
            <>
              <button onClick={onResume} className="btn-primary flex items-center justify-center gap-2">
                <Play size={18} />
                Resume
              </button>
              <button onClick={onStart} className="btn-secondary flex items-center justify-center gap-2">
                <RotateCcw size={18} />
                Restart
              </button>
            </>
          ) : (
            <button onClick={onStart} className="btn-primary flex items-center justify-center gap-2 text-lg py-4">
              <Play size={22} />
              PLAY NOW
            </button>
          )}

          <button className="btn-secondary flex items-center justify-center gap-2">
            <Trophy size={18} />
            Leaderboard
          </button>
          <button className="btn-secondary flex items-center justify-center gap-2">
            <Settings size={18} />
            Settings
          </button>
          <button onClick={onQuit} className="btn-secondary flex items-center justify-center gap-2">
            <Home size={18} />
            Main Menu
          </button>
        </div>
      </motion.div>
    </motion.div>
  )
}